import React, { useEffect, useState } from "react";
import Teamimage from "./Images/Team.svg";
import facebook from "./Images/facebook.png";
import insta from "./Images/insta.png";
import linkdin from "./Images/linkdin.svg";
import AditySoni from '../../TeamImages/Aditya_soni.jpg'
import AnilJain from '../../TeamImages/Anil_jain.jpg'
import ArunSharma from '../../TeamImages/arun_sharma.jpg'
import ArvindBatra from '../../TeamImages/Arvind_Batra.jpg'
import AshishBhardwaj from '../../TeamImages/ashish_bharadwaj.jpg'
import Babulalsaini from '../../TeamImages/Babu_lal_saini.jpg'
import Bharvi from '../../TeamImages/Bharvi_Maheshwari.jpg'
import Anjana from '../../TeamImages/Dr._Anjana_verma.jpg'
import saroj from '../../TeamImages/Dr._Saroj_Sharma.jpg'
import Narendra from '../../TeamImages/Dr._Narenda_Singh_Choudhary.jpeg'
import Ganesh from '../../TeamImages/ganesh.jpg'
import Kshitij from '../../TeamImages/Kshitij_choudhary.jpg'
import Piyush from '../../TeamImages/Piyush_Vijayvergiya.jpg'
import Pooja from '../../TeamImages/Pooja_Tosniwal.jpg'
import Pratit from '../../TeamImages/Pratit_Vijayvergia.png'
import Ramnik from '../../TeamImages/RAMNIK_JAIN.jpg'
import Rishi from '../../TeamImages/Rishi_Joshi.jpeg'
import Sachin from '../../TeamImages/sachin golechha.jpg'
import Sanjay from '../../TeamImages/Sanjay_Jaipuria.jpg'

import Sharad from '../../TeamImages/Sharad_Rathi.jpg'
import Shekhar from '../../TeamImages/Shekhar Bansal.jpg'
import Shyam from '../../TeamImages/Shyam Sunder Gupta.jpg'
import Siddhart from '../../TeamImages/Siddarth Tyagi.jpg'
import Sumit from '../../TeamImages/sumit dhadda.jpg'
import Sunil from '../../TeamImages/sunill_sucklecha.jpg'

import Vikas_Sharma from '../../TeamImages/Vikas_Sharma.jpeg'
import Vikas_Solanki from '../../TeamImages/Vikas_Solanki.jpeg'
import Vipan_Bahl from '../../TeamImages/Vipan bahl.jpg'

import Rajamohan from './Images/rajamohan.jpg';
import leonardo from './Images/leonardo.jpeg';
import Mark from './Images/mark.jpg';
import sachin from './Images/sachin_gujar.jpg';
import axios from "axios";

interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
}

const LeaderShipTeamsRBM = () => {
const api = process.env.REACT_APP_API_URL as string;
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState('sms');
  const [mobile, setMobile] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const[otpgenerated, setotpgenerated]  = useState('');
    const [newData, setNewData] = useState<UserStructure[]>([]);
  const array2 = [
    {
      name: 'Rajamohan Dhandapani',
      position: 'Chair',
      organization: 'Chair',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair',
      Profile_Picture: `${Rajamohan}`,
    },
    {
      name: 'Arvind Batra',
      position: 'Vice Chair',
      organization: 'Globe Communication',
      ContactNumber: '9214001400',
      Email_id: 'globejpr@gmail.com',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Vice  Chair',
      Profile_Picture: `${ArvindBatra}`,
    },
    {
      name: 'Mark Burchill',
      position: 'Chair Emeritus and Treasurer',
      organization: 'Chair Emeritus and Treasurer',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair Emeritus and Treasurer',
      Profile_Picture: `${Mark}`,
    },
    {
      name: 'Sachin Gururaj',
      position: 'Chair Emeritus & Immediate Past Chair',
      organization: 'Chair Emeritus & Immediate Past Chair',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair Emeritus & Immediate Past Chair',
      Profile_Picture: `${sachin}`,
    },
    {
      name: 'leonardo santos',
      position: 'Secretary',
      organization: 'Secretary',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Secretary',
      Profile_Picture: `${leonardo}`,
    },
  ];

   useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<UserStructure[]>(
            `${api}/auth/allusersinfo`
          );
  
          setNewData(response.data);
        } catch (error) {
          console.error("user Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  

  return (
    <div>
      <div className="bg-[#101729] py-14 px-[8%] ">
        <div className="flex flex-wrap w-[100%] justify-between ">
          <div className=" sm:w-[50%]">
            <span className="text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
              RMBF Leaders
            </span>
            <span className="text-[#FDBC12] text-[39px] leading-10	font-bold	">
              
            </span>
          </div>
          <div className=" sm:w-[50%]">
            <span className="hidden text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
              2026-27
            </span>
            
          </div>
        </div>
        <div>
          <div className="w-[100%] flex flex-wrap justify-between mt-[70px] gap-y-10 ">
          {newData.filter((items)=>items.role =='Leader').map((data, index) =>(
            <div className=" flex flex-wrap lg:w-[48%] w-[100%] gap-4">
            <div className=" w-[200px] h-[200px] p-3 border-2 border-[#FDBC12] rounded-full flex justify-center items-center">
                <img className=" w-full h-full rounded-full object-cover" src={`${api}/${data.profile}`} alt="" />
            </div>
            <div className=" sm:w-[60%] w-[100%] flex flex-col justify-center sm:mt-0 mt-4">
            <h5 className="sm:text-[24px] text-[18px] font-semibol text-[#F5F5F5]">{data.name}</h5>
            <p className="text-[14px] font-semibol text-[#D7D3D2]">{data.role}</p>
            <div className="w-[171px] h-[2px] bg-[#FDBC12] mt-5"></div>
            <p className="text-[12px] text-[#94A2B8] mt-5 h-[95px]">{data.company_name}</p>
          
            </div>
           
         
          </div>
          ))}
          </div>
        </div>
        <div>
          
        </div>
      </div>
    </div>
  );
};

export default LeaderShipTeamsRBM;
